// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pending-change-badge[data-v-7529566f] {\n  padding: 8px;\n}\n.current-plan-badge[data-v-7529566f] {\n  border: 2px solid;\n  padding: 5px;\n}", ""]);
// Exports
module.exports = exports;
